import React from 'react';
import { useTranslation } from 'react-i18next';
import { StudentInfo } from '../../types/form';
import { getInitials } from '../../utils/helpers';
import './InfoSection.css';

interface InfoSectionProps {
  studentInfo: StudentInfo;
}

const InfoSection: React.FC<InfoSectionProps> = ({ studentInfo }) => {
  const { t } = useTranslation();

  const studentFullName = `${studentInfo.studentFirstName || ''} ${studentInfo.studentLastName || ''}`.trim();
  const studentInitials = getInitials(studentFullName);

  return (
    <div className="student-info-card">
      <div className="student-avatar">
        <span className="avatar-initials">{studentInitials}</span>
      </div>
      <div className="student-info-content">
        <div className="student-info-main">
          <div className="student-name">{studentFullName || '—'}</div>
          <div className="student-details">
            <span className="student-detail-item">
              <span className="student-detail-label">{t('form.infoSection.studentId')}:</span>
              <span className="student-detail-value">{studentInfo.studentId || '—'}</span>
            </span>
            <span className="student-detail-separator">•</span>
            <span className="student-detail-item">
              <span className="student-detail-label">{t('form.infoSection.studentGrade')}:</span>
              <span className="student-detail-value">{studentInfo.studentGrade || '—'}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoSection;

